import { trackEvent as trackEvent$1 } from '@zooplus/tracker-listener';
import { APPLE_PAY_CONTAINER_ID } from '../features/ApplePay/AdyenApplePayButton/AdyenApplePayButton.static.js';
import { useAppContext } from '../providers/AppContextProvider.js';
import { captureException } from '../services/sentryService.js';

const trackEvent = (event) => trackEvent$1(event);
const PAYMENT_SAVE_BUTTON = 'payment-save-button';
const EVENTS_MAP = {
    Braintree_3DSWindow_Displayed: {
        event: 'IMPRESSION',
        page: 'CHECKOUT_PREVIEW',
        target: {
            name: 'Braintree_3DSWindow',
            id: 'Braintree_3DSWindow_Displayed',
        },
    },
    Click_3DSCancel: {
        event: 'IMPRESSION',
        page: 'CHECKOUT_PREVIEW',
        target: {
            name: 'Braintree_3DS_Modal',
            id: 'Click_3DSCancel',
        },
    },
    AdyenFormOK: {
        event: 'CLICK',
        page: 'CHECKOUT_PREVIEW',
        target: {
            name: 'modernize_payment_component_Save_button',
            id: PAYMENT_SAVE_BUTTON,
        },
    },
    AdyenFormKO: {
        event: 'CLICK',
        page: 'CHECKOUT_PREVIEW',
        target: {
            name: 'modernize_payment_component_Save_button',
            id: PAYMENT_SAVE_BUTTON,
        },
    },
    PaymentSheetOpen: {
        event: 'CLICK',
        page: 'CHECKOUT_PREVIEW',
        target: {
            name: 'ApplePay_BuyButton',
            id: APPLE_PAY_CONTAINER_ID,
        },
    },
    PaymentSheetCloseOK: {
        event: 'INTERACTION',
        page: 'CHECKOUT_PREVIEW',
        target: {
            name: 'ApplePay_PaymentSheet',
            id: 'PaymentSheetCloseOK',
        },
    },
    PaymentSheetCloseKO: {
        event: 'INTERACTION',
        page: 'CHECKOUT_PREVIEW',
        target: {
            name: 'ApplePay_PaymentSheet',
            id: 'PaymentSheetCloseKO',
        },
    },
};
const useTracking = (options) => {
    const { locale } = useAppContext();
    const { sid, currency, customerId, siteId, guest } = options ?? {};
    if (!sid || !currency || !customerId) {
        console.error('Needed tracking options are undefined');
        return undefined;
    }
    return (type) => {
        const knownEvent = EVENTS_MAP[type];
        if (typeof window === 'undefined') {
            captureException(new Error('useTracking called outside of browser'));
            return undefined;
        }
        if (!knownEvent) {
            captureException(new Error('Event does not exist'));
            return undefined;
        }
        const event = {
            event: knownEvent.event,
            page: knownEvent.page,
            detail: {
                sid,
                platform: 'WEB',
                domain: window.location.hostname,
                siteId,
                locale,
                currencyCode: currency,
                pageLocation: window.location.href,
                target: EVENTS_MAP[type].target,
                customer: {
                    id: `${customerId}`,
                    guest: guest,
                },
            },
        };
        return trackEvent(event);
    };
};

export { useTracking };
//# sourceMappingURL=useTracking.js.map
